// Layers tab. Edit mode: full CRUD + drag-reorder. View mode: visibility
// toggles only (applied locally, never saved).

import { esc, eyeToggle } from './html';

export function layersPanelHtml(state, { viewOnly } = {}) {
  const rows = state.layers.map((l) => (viewOnly
    ? `
      <div class="pl2-row" data-layer-id="${esc(l.id)}">
        ${eyeToggle(`data-pl2="layer-visible" data-id="${esc(l.id)}"`, l.visible !== false, 'Visible')}
        <span class="pl2-row__name">${esc(l.name)}</span>
      </div>`
    : `
      <div class="pl2-row" data-layer-id="${esc(l.id)}">
        <span class="pl2-drag" data-drag-handle title="Drag to reorder">⠿</span>
        ${eyeToggle(`data-pl2="layer-visible" data-id="${esc(l.id)}"`, l.visible !== false, 'Visible')}
        <input class="pl2-input pl2-layer-name" data-pl2="layer-rename" data-id="${esc(l.id)}" value="${esc(l.name)}">
        <input type="range" class="pl2-range" min="0" max="1" step="0.05" value="${l.opacity ?? 1}" data-pl2="layer-opacity" data-id="${esc(l.id)}" title="Opacity">
        <button class="pl2-iconbtn" data-pl2="layer-delete" data-id="${esc(l.id)}" title="Delete layer">×</button>
      </div>`)).join('');
  const add = viewOnly ? '' : '<button class="pl2-btn" data-pl2="layer-add" style="margin-top:8px">+ Add layer</button>';
  return `<h3 class="pl2-section-title">Layers</h3><div class="pl2-layer-list">${rows}</div>${add}`;
}
